enum QuantityStepperType {
  OUTLINED = 'outlined',
  FILLED = 'filled',
}

enum QuantityStepperSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export { QuantityStepperType, QuantityStepperSize };
